import util from '@/libs/util.js'
import router from '@/router'
import {
  AccountLogin
} from '@/api/sys.login'

export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login({
      dispatch
    }, {
      username = '',
      password = ''
    } = {}) {
      return new Promise((resolve, reject) => {
        // 开始请求登录接口
        AccountLogin({
            username,
            password
          })
          .then(async res => {
            // 设置 cookie 一定要存 uuid 和 token 两个 cookie
            // 整个系统依赖这两个数据进行校验和存储
            // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
            // token 代表用户当前登录状态 建议在网络请求中携带 token
            // 如有必要 token 需要定时更新，默认保存一天
            util.cookies.set('uuid', res.uuid)
            util.cookies.set('token', res.token)
            // 设置 vuex 用户信息
            dispatch('admin/user/set', res, {
              root: true
            })
            // 用户登录后从持久化数据加载一系列的设置
            dispatch('load')
            // 结束
            resolve()

          })
          .catch(err => {
            let res = {
              uuid: "33333333333333333333",
              token: "88999999999999999999"
            }
            util.cookies.set('uuid', res.uuid)
            util.cookies.set('token', res.token)

            // 设置 vuex 用户信息
            dispatch('admin/user/set', res, {
              root: true
            })
            // 用户登录后从持久化数据加载一系列的设置
            dispatch('load')
            // 结束

            console.log('err: ', err)
            resolve()
            reject(err)
            //  this.$router.replace(this.$route.query.redirect || "/index");
          })
      })
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout({
      dispatch
    }) {
      //注销

      util.cookies.remove('token')
      util.cookies.remove('uuid')
      // 清空 vuex 用户信息
      dispatch('admin/user/set', {}, {
        root: true
      })
      // 跳转路由
      router.push({
        name: 'login'
      })
      // end


    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load({
      dispatch
    }) {
      return new Promise(resolve => {
        // DB -> store 加载用户名
        dispatch('admin/user/load', null, {
          root: true
        });
        // dispatch('admin/theme/load', null, {
        //   root: true
        // })
        // // DB -> store 持久化数据加载侧边栏菜单
        // await dispatch('admin/menu/asideGet', null, {
        //   root: true
        // })
        // end
        resolve()
      })
    }
  }
}